// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"ca59ad909dce0d00","741":"9872d9cd25028864"}[chunkId] + ".js";
};